import { Injectable, HostListener } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // check mobile size
  mobileSize = false;
  // set loadding in interceptor
  globalLodding$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  downloadFile(FileLink) {
    let link = document.createElement('a');
    link.href = FileLink;
    link.download = FileLink;
    link.click();
    link.remove();
  }
  /**
   * @description check file type png or jpeg and image size under 512
   * @param event file
   * @returns boolean
   */
  validImage(event: any): boolean {
    if (!event.target.files[0]) {
      return false;
    }
    if (!(event.target.files[0].type === 'image/jpeg' ||
      event.target.files[0].type === 'image/webp' ||
      event.target.files[0].type === 'image/png')) {
      this.showErrorSnackBar('پسوند عکس باید png یا jpeg باشد!!');
      return false;
    } else if (Math.round(event.target.files[0].size / 1024) > 1024) {
      this.showErrorSnackBar('حجم عکس باید کمتر از 1 مگابایت باشد!!');
      return false;
    } else {
      return true;
    }
  }
  convertNumberPriceToNumber(credit): void {
    return credit.toString().replace(/,/g, '');
  }

  showSnackBar(message: string, action?: string, duration?: number): void {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: 'left',
      panelClass: 'customSnackBar'
    });
  }

  showErrorSnackBar(message: string, action?: string, duration?: number): void {
    this.snackBar.open(message, action || null, {
      duration: duration || 1500,
      direction: 'rtl',
      horizontalPosition: 'left',
      panelClass: 'customErrorSnackBar'
    });
  }

  /**
   * @description set value loadingSrc in app component for show loadding
   */
  changeStateLodding(data: boolean): void {
    this.globalLodding$.next(data);
  }
  /**
   * @description show snakbar
   * @param message string
   * @param action string optional
   * @param duration number optional
   */
  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  })
}
